<script>
import modalUploadImage from "../modals/modal-upload-image";

export default {
  name: "personalInformation",
  components: {
    modalUploadImage,
  },
  data() {
    return {
      user: this.$A.Auth,
      isMobile: window.innerWidth < 991,
      emailChanged: false
    };
  },
  computed: {
    userInitials() {
      const name = _.get(this, "user.name", "") || "";
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return "?";
      return parts
        .slice(0, 2)
        .map((p) => p[0].toUpperCase())
        .join("");
    },
  },
  methods: {
    showUploadImageModal: function () {
      this.$refs.uploadImageModal.openModal();
    },
    updateUserInfo: async function () {
      const curUser = _.get(this, 'user', {});
      let user = await this.$A.UserService.UpdateUser(
          curUser.id,
          {
            name : curUser.name,
            email : curUser.email,
            phone : curUser.phone,
            title : curUser.title,
          }
      );
      if (user && user.id > 0) {
        this.$A.Auth = user;
        this.$A.SaveSessionData(this.$A.Auth);
      }
      this.emailChanged = false;
    },
    setEmailChanged: function () {
      this.emailChanged = true
    }
  },
  mounted() {
    let self = this;
    this.$root.$on("profile::photo::updated", function (image) {
      _.set(self, 'user.profileImageUrl', image);
    });
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">My Information</div>
      <div class="card-head-subtitle">Your name, contact details, and profile photo.</div>
    </div>
    <div class="card-body-grid" v-if="user">
      <!-- Profile Photo -->
      <div class="photo-block">
        <button
          v-if="user.profileImageUrl"
          type="button"
          class="photo-avatar"
          :style="{ backgroundImage: 'url(' + user.profileImageUrl + ')' }"
          title="Change profile photo"
          @click="showUploadImageModal"
        >
          <span class="photo-overlay">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
            Change
          </span>
        </button>
        <button
          v-else
          type="button"
          class="photo-avatar photo-empty"
          title="Add a profile photo"
          @click="showUploadImageModal"
        >
          <span class="photo-empty-initials">{{ userInitials }}</span>
          <span class="photo-empty-hint">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Add photo
          </span>
        </button>
        <button type="button" class="secondary-btn photo-btn" @click="showUploadImageModal">
          Upload Profile Photo
        </button>
      </div>

      <!-- Fields -->
      <div class="fields-block">
        <div class="field-grid">
          <div class="field">
            <label class="field-label" for="profileName">Name</label>
            <input
                id="profileName"
                type="text"
                name="profileName"
                class="text-input"
                placeholder="Your Name"
                v-model="user.name"
            />
          </div>
          <div class="field">
            <label class="field-label" for="profileEmail">Email</label>
            <input
                id="profileEmail"
                type="text"
                name="profileEmail"
                class="text-input"
                placeholder="Your Email"
                v-model="user.email"
                @change="setEmailChanged"
            />
          </div>
          <div class="field">
            <label class="field-label" for="profilePhoneNumber">Phone</label>
            <input
                id="profilePhoneNumber"
                type="text"
                name="profilePhoneNumber"
                class="text-input"
                placeholder="Your Phone Number"
                v-model="user.phone"
            />
          </div>
          <div class="field">
            <label class="field-label" for="profileTitle">Title</label>
            <input
                id="profileTitle"
                type="text"
                name="profileTitle"
                class="text-input"
                placeholder="Your Title"
                v-model="user.title"
            />
          </div>
        </div>
        <div class="warning-banner" v-if="emailChanged">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          Updating your email address will require re-verification for any existing email settings.
        </div>
      </div>
    </div>
    <div class="card-foot">
      <a data-cy="updatedUserInfoBtn" class="primary-btn" @click="updateUserInfo">Update</a>
    </div>
    <modalUploadImage type="profile" ref="uploadImageModal"/>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body-grid {
  display: flex;
  gap: 28px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

/* Photo */
.photo-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.photo-avatar {
  position: relative;
  width: 132px;
  height: 132px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background-position: center;
  background-size: cover;
  background-color: #fff;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
}
.photo-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(17, 24, 39, 0.45);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 120ms ease;
}
.photo-avatar:hover .photo-overlay {
  opacity: 1;
}
.photo-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1.5px dashed #c2c8d0;
  background: rgba(1, 146, 86, 0.04);
  transition: border-color 120ms ease, background-color 120ms ease;
}
.photo-empty:hover {
  border-color: #019256;
  background: rgba(1, 146, 86, 0.08);
}
.photo-empty-initials {
  font-size: 30px;
  font-weight: 700;
  color: #017a48;
  letter-spacing: 0.02em;
}
.photo-empty-hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  color: #6b7280;
}

/* Fields */
.fields-block {
  flex: 1;
  min-width: 0;
}
.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.text-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.text-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(235, 70, 84, 0.08);
  color: #b43643;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.5;
}
.warning-banner svg {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 14px;
  background: #fff;
  color: #1f2937;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 120ms ease, color 120ms ease;
}
.secondary-btn:hover {
  border-color: #019256;
  color: #019256;
}

@media (max-width: 767px) {
  .card-body-grid {
    flex-direction: column;
    align-items: center;
  }
  .fields-block {
    width: 100%;
  }
  .field-grid {
    grid-template-columns: 1fr;
  }
  .primary-btn {
    width: 100%;
  }
}
</style>
